import { createStore } from 'vuex';

export default createStore({
  state() {
    return {
      
    };
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});